class CwReviewBadge extends HTMLElement {
  connectedCallback() {
    this.storageKey = 'cw-review-badge-dismissed';

    if (!this.hasAttribute('data-design-mode') && this.isDismissed()) return;

    this.hidden = false;

    const closeButton = this.querySelector('[data-cw-review-badge-close]');
    if (closeButton) {
      closeButton.addEventListener('click', () => this.dismiss());
    }
  }

  isDismissed() {
    try {
      return window.sessionStorage.getItem(this.storageKey) === 'true';
    } catch (error) {
      return false;
    }
  }

  dismiss() {
    this.hidden = true;

    if (this.hasAttribute('data-design-mode')) return;

    try {
      window.sessionStorage.setItem(this.storageKey, 'true');
    } catch (error) {
      return;
    }
  }
}

if (!customElements.get('cw-review-badge')) {
  customElements.define('cw-review-badge', CwReviewBadge);
}
